module.exports = __webpack_public_path__ + "media/images/pdf-edb1cd5622c8fe66690a0b2928db64a6.png";